import {User} from "./User";
import {CreditRecord} from "./CreditRecord"

export class Applicant {
    public givenName: string;
    public familyName: string;
    public preferredName: string;
    public email: string;
    public studentId: string;
    public applicantId: string;
    public phoneNumber: string;
    public isProspectiveStudent: boolean;
    public creditRecords: CreditRecord[]

    public static fromUser(user: User): Applicant {
        const applicant = new Applicant();
        applicant.email = user.email;
        applicant.familyName = user.surName;
        applicant.givenName = user.givenName;
        applicant.preferredName = user.preferredName;
        applicant.studentId = user.callistaPersonId;
        applicant.applicantId = user.applicantId;
        applicant.email = user.email;
        applicant.isProspectiveStudent = user.isProspectiveStudent;

        return applicant;
    }

    public fullName(): string {
        return `${this.givenName} ${this.familyName}`;
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/Applicant.ts